module.exports = __webpack_public_path__ + "img/light_online.8466a3ef.png";